import Image from "./Image";
import prefetchImage from "./helpers/prefetchImage";
import type { ImageProps } from "./types";

export { prefetchImage };
export type { ImageProps };
export default Image;
